import './bootstrap';
import 'bootstrap';

$('.clickable-row').click(function (e) {
    var target = $(this).data('href');

    if (target) {
        window.document.location = target;
    }
});

// Integer format
$('body').on('keypress', 'input[data-allow="integer"]', function(evt) {
    var charCode = (evt.which) ? evt.which : event.keyCode;

    if ((charCode < 48 || charCode > 57)) {
        evt.preventDefault();
    }
});
